
// DEPRECATED: This component has been replaced with secure Supabase authentication
// AdminPinAuth is no longer used for security reasons - it was replaced with proper role-based authentication

import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, AlertTriangle, ArrowLeft } from 'lucide-react';

interface AdminPinAuthProps {
  onAuthSuccess: () => void;
  onCancel?: () => void;
}

export const AdminPinAuth = ({ onAuthSuccess, onCancel }: AdminPinAuthProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-white p-4">
      <div className="w-full max-w-md space-y-4">
        {onCancel && (
          <Button 
            variant="outline" 
            onClick={onCancel}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Login
          </Button>
        )}
        <Card className="w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <AlertTriangle className="w-16 h-16 text-red-600" />
          </div>
          <CardTitle className="text-xl text-red-800">Security System Updated</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h4 className="font-medium text-red-800 mb-2">PIN Authentication Disabled</h4>
            <p className="text-sm text-red-700">
              The PIN-based authentication system has been replaced with secure Supabase authentication for improved security.
            </p>
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-medium text-blue-800 mb-2">New Authentication Required</h4>
            <p className="text-sm text-blue-700">
              Please log in with your admin account through the main authentication system to access admin features.
            </p>
          </div>
          
        </CardContent>
      </Card>
      </div>
    </div>
  );
};
